import { createContext, ReactNode, useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import type { Stripe } from '@stripe/stripe-js';

import useLoadStripe from 'src/hooks/use-load-stripe';
import { CURRENT_LOCALE, IS_STRIPE } from 'src/constants';

interface StripeContextProps {
  stripe: Stripe | null;
}

export const initialStripeContextProps = {
  stripe: null,
};

export const StripeContext = createContext<StripeContextProps>(initialStripeContextProps);

const StripeProvider = ({ children }: { children: ReactNode }) => {
  const stripe = useLoadStripe();

  return (
    <StripeContext.Provider value={{ stripe }}>
      {IS_STRIPE && (
        <Elements options={{ locale: CURRENT_LOCALE }} stripe={stripe}>
          {children}
        </Elements>
      )}
    </StripeContext.Provider>
  );
};

const useStripeContext = () => useContext(StripeContext);

export { StripeProvider, useStripeContext };
